import { useState } from 'react'
import { IFilterMultiSelectOption } from 'transfix-ui/components/FilterMultiSelect'
import { TQuoteFilters } from '../../../types'
import { getMultiStopSelectedValues } from '../utils/getMultiStopSelectedValues'

interface IUseMultiStopProps {
  quotesFilters: TQuoteFilters
  setQuotesFilters: React.Dispatch<React.SetStateAction<TQuoteFilters>>
}

export const useMultiStop = ({ quotesFilters, setQuotesFilters }: IUseMultiStopProps) => {
  const [areBothBoxesSelected, setAreBothBoxesSelected] = useState<boolean>(false)
  const getMultiStopFilterOptions = (quotesFilters: TQuoteFilters) => {
    const multiStopOptions: IFilterMultiSelectOption[] = [
      {
        value: 'false',
        label: 'Single PU/DEL',
        selected: quotesFilters.isMultiStop === false || areBothBoxesSelected,
      },
      {
        value: 'true',
        label: 'Multiple PU/DEL',
        selected: quotesFilters.isMultiStop === true || areBothBoxesSelected,
      },
    ]
    return multiStopOptions
  }

  const multiStopHandler = (selected?: IFilterMultiSelectOption[]) => {
    if (selected) {
      const isMultiStop = getMultiStopSelectedValues(selected)
      const updatedFilters = {
        ...quotesFilters,
        isMultiStop,
      }
      setQuotesFilters(updatedFilters)
      if (selected.every(option => option.selected === true) && isMultiStop === undefined) {
        setAreBothBoxesSelected(true)
      } else {
        setAreBothBoxesSelected(false)
      }
    } else {
      setAreBothBoxesSelected(false)
    }
  }

  const multiStopOptions = getMultiStopFilterOptions(quotesFilters)

  return { multiStopOptions, multiStopHandler }
}
